import React from "react";
import { Button } from "reactstrap";

/**
 * Formik button input.
 * Can be used similar as on/off field or as a group of input fields.
 */
function ButtonInput({
  field,
  meta,
  helpers,
  onClick,
  option,
  optionLabelKey,
  optionValueKey,
  optionIconKey,
  group,
  block,
  isChecked,
  ...props
}) {
  const id = `${field.name}-${option[optionValueKey]}`;
  const disabled = props.disabled || option.disabled;
  const Icon = optionIconKey ? option[optionIconKey] : null;
  return (
    <Button
      {...props}
      id={id}
      active={isChecked}
      aria-label={props["area-label"] || option[optionLabelKey]}
      block={!group && block}
      disabled={disabled}
      name={field.name}
      onBlur={field.onBlur}
      onClick={onClick}
    >
      {Icon ? <Icon /> : null}
      {option[optionLabelKey]}
    </Button>
  );
}

export default ButtonInput;
